import { strings } from '@stores'
import find from 'lodash/find'
import { storage } from './storageService'
import { HttpService } from './HttpService'
import { config } from '@config'
const httpService = new HttpService()

const getOptionsHeader = () => {
  const accessToken: string = storage.getItem('access_token')
  return {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  }
}

const getWholesaleChannelValue = enumValues => {
  return find(enumValues, ['Name', strings.wholeSaleChannelName])
}

const getClusters = async (channelId?: string) => {
  return httpService
    .get(`${config.buyingBoardServiceRestEndpoint}core/cluster`, {
      ...getOptionsHeader(),
      params: { ...(channelId ? { channelId } : {}) }
    })
    .then(response => response?.data)
}

const deleteClusterById = async clusterId => {
  return httpService
    .delete(`${config.buyingBoardServiceRestEndpoint}core/cluster/${clusterId}`, {
      ...getOptionsHeader()
    })
    .then(response => response)
}

const createCluster = async ({ channel, name, colorHex }) => {
  return httpService
    .post(
      `${config.buyingBoardServiceRestEndpoint}core/cluster`,
      {
        channelId: channel,
        name: name,
        rgbHex: colorHex
      },
      {
        ...getOptionsHeader()
      }
    )
    .then(response => response)
}
const updateCluster = async cluster => {
  return httpService
    .post(`${config.buyingBoardServiceRestEndpoint}core/cluster/update`, cluster, {
      ...getOptionsHeader()
    })
    .then(response => response)
}
export {
  getWholesaleChannelValue,
  deleteClusterById,
  getClusters,
  createCluster,
  updateCluster
}
